import styled from 'styled-components'
import { Checkbox } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import theme from 'config/theme'

export const StyledSelectorWrapper = styled.div`
  margin-top: 10px;
`

export const StyledWrapper = styled.div`
  flex-direction: column;
  width: 50%;
  margin: 0px 10px 0px 10px;
`

export const Text = styled.text`
  margin: auto auto;
`

export const WrapperCheckbox = styled.div`
  display: flex;
  margin: 0px 0px 0px 10px;
`

export const WrapperSelect = styled.div`
  display: flex;
  margin: 0px 10px 0px 10px;
  margin-top: 20px;
`

export const SwitchWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`

export const Select = styled.div`
  width: 85%;
`

const checkBoxStyles = {
  root: {
    '&$checked': {
      color: theme.colors.purple
    }
  },
  checked: {}
}

export const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox)
